export default function getCards(contact, assignedUsers, customFields, addresses, types, statuses, sources, ownerUsers, optinStatuses, emailStatus) {
  const type = contact.hasOwnProperty('type') ? contact.type : {};
  return [
    {
      column_position: 'left',
      card_title: 'Primary Details',
      card_action: '',
      card_id: 'primary_details',
      order: 1,
      card_component: "RegularCard",
      fields: [
        {
          name: 'Primary Email',
          value: contact.email || '',
          data_type: 'text',
          id: 'email',
          icon: '',
        },
        {
          name: 'Secondary Email',
          value: contact.secondary_email || '',
          data_type: 'text',
          id: 'secondary_email',
          icon: '',
        },
        {
          name: 'Mobile Phone',
          value: contact.mobile_phone || '',
          data_type: 'text',
          id: 'mobile_phone',
          icon: '',
        },
        {
          name: 'Home Phone',
          value: contact.home_phone || '',
          data_type: 'text',
          id: 'home_phone',
          icon: '',
        },
        {
          name: 'Office Phone',
          value: contact.office_phone || "",
          data_type: 'text',
          id: 'office_phone',
          icon: '',
        },
        {
          name: 'Company',
          value: contact.company || "",
          data_type: 'text',
          id: 'company',
          icon: '',
        },
        {
          name: 'Birthday',
          value: contact.birthday || "",
          data_type: 'date',
          id: 'birthday',
          icon: '',
        },
        {
          name: 'Anniversary',
          value: contact.anniversary || "",
          data_type: 'date',
          id: 'anniversary',
          icon: '',
        },
        {
          name: 'Source',
          value: contact.source_id || 0,
          data_type: 'select',
          id: 'source_id',
          icon: '',
          options: sources
        },
        {
          name: 'Type',
          value: type.id || 0,
          data_type: 'select',
          id: 'type_id',
          icon: '',
          options: types
        },
        {
          name: 'Status',
          value: contact.status || '',
          data_type: 'select',
          id: 'status',
          icon: '',
          options: statuses
        },
        {
          name: 'Assigned to',
          value: contact.assigned_user_id || 0,
          data_type: 'select',
          id: 'assigned_user_id',
          icon: '',
          options: assignedUsers
        },
        {
          name: 'Owner',
          value: contact.owner_user_id || 0,
          data_type: 'select',
          id: 'owner_user_id',
          icon: '',
          options: ownerUsers
        },
      ]
    },
    {
      column_position: 'left',
      card_title: 'Custom Fields',
      card_action: '+ Add',
      card_id: 'custom_fields',
      card_component: "RegularCard",
      order: 2,
      fields: customFields
    },
    {
      column_position: 'left',
      card_title: 'Spouse Information',
      card_action: '',
      card_id: 'spouse_information',
      card_component: "RegularCard",
      order: 4,
      fields: [
        {
          name: 'Spouse Name',
          value: contact.spouse_name || '',
          data_type: 'text',
          id: 'spouse_name',
          icon: ''
        },
        {
          name: 'Spouse Email',
          value: contact.spouse_email || '',
          data_type: 'email',
          id: 'spouse_email',
          icon: ''
        },
        {
          name: 'Spouse Phone',
          value: contact.spouse_phone || '',
          data_type: 'text',
          id: 'spouse_phone',
          icon: ''
        },
        {
          name: 'Birthday',
          value: contact.spouse_birthday || '',
          data_type: 'date',
          id: 'spouse_birthday',
          icon: ''
        },
      ]
    },
    {
      column_position: 'left',
      card_title: 'Addresses',
      card_action: '+ Add',
      card_id: 'addresses',
      card_component: "AddressFields",
      order: 5,
      fields: addresses
    },
    {
      column_position: 'left',
      card_title: 'Text Opt-In Status',
      card_id: 'optin_status',
      card_component: "OptinStatus",
      order: 6,
      expand_description: true,
      fields: optinStatuses,
    },
    {
      column_position: 'left',
      card_title: 'Email Status',
      card_id: 'email_status',
      card_component: "EmailStatus",
      order: 7,
      expand_description: true,
      fields: emailStatus,
    },
    {
      column_position: 'right',
      card_title: 'Leads History',
      card_action: '+ Add',
      card_id: 'leads_history',
      order: 0,
      card_component: 'UnderContruction',
    },
    {
      column_position: 'right',
      card_title: 'Contact List',
      card_action: '+ Add',
      card_id: 'contact_list',
      order: 1,
      card_component: 'UnderContruction',
    },
    {
      column_position: 'right',
      card_title: 'Documents',
      card_action: '+ Add',
      card_id: 'documents',
      order: 2,
      card_component: 'UnderContruction',
    },
    {
      column_position: 'right',
      card_title: '3rd Party Integrations',
      card_action: '',
      card_id: '3rd_party_integrations',
      order: 3,
      card_component: 'UnderContruction',
    },
    {
      column_position: 'right',
      card_title: 'Associated Parties',
      card_action: '',
      card_id: 'associated_parties',
      order: 4,
      card_component: 'UnderContruction',
    },
    {
      column_position: 'right',
      card_title: 'Website Activity',
      card_action: '',
      card_id: 'website_activity',
      order: 5,
      card_component: 'UnderContruction',
    },
    {
      column_position: 'right',
      card_title: 'Advertising',
      card_action: '',
      card_id: 'advertising',
      order: 6,
      card_component: 'UnderContruction',
    },
  ];
}
